import axios from "axios";
import initmixin from "./initmixin";

/**
 * Servicio para el manejo de Bonos de Productividad
 * @module bonoProductividad
 */
export default {
  /**
   * Calcula el bono grupal del mes actual o de un mes específico
   * @param {number} mes - Mes a consultar (1-12) - Opcional
   * @returns {Promise} Respuesta con el cálculo del bono
   */
  async calcularBono(mes = null) {
    let url = "bono-productividad/grupal/calcular";
    
    // Agregar query parameter solo si se especifica el mes
    if (mes !== null) {
      url += `?mes=${mes}`;
    }
    
    const response = await initmixin.formatrespuesta(
      "get",
      null,
      url,
      true
    );

    // Mapear la respuesta del backend al formato esperado por el frontend
    if (response && response.exito) {
      return {
        success: true,
        data: {
          bono_ganado: response.bono?.ganado || false,
          monto_bono: response.bono?.monto || 0,
          estado_bono: response.bono?.estado || 'PERDIDO',
          periodo: {
            mes: response.periodo?.mes_nombre || '',
            anio: response.periodo?.año || new Date().getFullYear(),
            fecha_inicio: response.periodo?.fecha_inicio || '',
            fecha_fin: response.periodo?.fecha_fin || ''
          },
          estadisticas: {
            total_cotizaciones: response.metricas?.total_pedidos || 0,
            a_tiempo: response.metricas?.pedidos_a_tiempo || 0,
            retrasadas: response.metricas?.pedidos_fuera_de_tiempo || 0,
            porcentaje_cumplimiento: response.metricas?.porcentaje_cumplimiento || 0
          },
          criterios: {
            dias_habiles_limite: response.criterios?.dias_habiles_limite || 10,
            porcentaje_minimo: response.criterios?.porcentaje_minimo_requerido || 95,
            tolerancia_porcentaje: response.criterios?.tolerancia_porcentaje || 5,
            tolerancia_pedidos: response.criterios?.tolerancia_pedidos || 0
          },
          detalle_retrasos: response.detalle_pedidos || []
        }
      };
    }

    return response;
  },

  /**
   * Obtiene el historial de bonos grupales
   * @param {number} meses - Cantidad de meses a consultar (default: 12, máximo: 24)
   * @returns {Promise} Respuesta con el historial de bonos
   */
  obtenerHistorial(meses = 12) {
    return initmixin.formatrespuesta(
      "get",
      null,
      `bono-productividad/grupal/historial?meses=${meses}`,
      true
    );
  },
};
